import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

var useOnScroll = function useOnScroll() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrolledTo = _useState2[0],
    setScrolledTo = _useState2[1];
  var scrollRef = useRef();
  var handleScroll = function handleScroll(_ref) {
    var currPos = _ref.currPos;
    if (scrolledTo === false && currPos.y <= 0) setScrolledTo(true);
    if (scrolledTo === true && currPos.y >= 0) setScrolledTo(false);
  };
  useScrollPosition(handleScroll, [scrolledTo], scrollRef);
  return {
    scrollRef: scrollRef,
    scrolledTo: scrolledTo
  };
};
var useOnScroll$1 = useOnScroll;

export { useOnScroll$1 as default };
//# sourceMappingURL=useOnScroll.js.map
